import { render, staticRenderFns } from "./ButtonGradient.vue?vue&type=template&id=e9bfbcb6&"
import script from "./ButtonGradient.vue?vue&type=script&lang=js&"
export * from "./ButtonGradient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports